/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react'
import { supabase } from '../lib/supabase'

// ─── 制裁国家列表 ──────────────────────────────────────────
const SANCTIONED_COUNTRIES = [
  'Afghanistan', 'Belarus', 'Bosnia and Herzegovina', 'Burma (Myanmar)',
  'Central African Republic', 'Democratic Republic of Congo', 'Croatia',
  'Cuba', 'Ethiopia', 'Iran', 'Iraq', 'Kosovo', 'Lebanon', 'Libya',
  'Macedonia (North)', 'Mali', 'Montenegro', 'Nicaragua', 'North Korea',
  'Russian Federation', 'Serbia', 'Slovenia', 'Somalia', 'South Sudan',
  'Sudan', 'Syria', 'Ukraine', 'Venezuela', 'Yemen', 'Zimbabwe'
]

const ALL_COUNTRIES = [
  'Australia', 'Austria', 'Belgium', 'Brazil', 'Canada', 'China', 'Denmark',
  'Finland', 'France', 'Germany', 'Greece', 'Hong Kong', 'India', 'Indonesia',
  'Ireland', 'Israel', 'Italy', 'Japan', 'Luxembourg', 'Malaysia', 'Malta',
  'Mexico', 'Netherlands', 'New Zealand', 'Norway', 'Philippines', 'Poland',
  'Portugal', 'Saudi Arabia', 'Singapore', 'South Korea', 'Spain', 'Sweden',
  'Switzerland', 'Taiwan', 'Thailand', 'Turkey', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Vietnam',
  ...SANCTIONED_COUNTRIES
].sort()

// ─── 翻译 ─────────────────────────────────────────────────
const T = {
  en: {
    kycTitle: 'FinconnectX Platform — Individual Onboarding (KYC)',
    kybTitle: 'FinconnectX Platform — Corporate Onboarding (KYB)',
    subtitle: 'FinconnectX Platform',
    stepBasic: 'Basic Info', stepPersonal: 'Personal Info',
    stepBusiness: 'Business Info', stepBankWallet: 'Bank & Wallet',
    stepCompliance: 'Compliance', stepAgreements: 'Agreements',
    stepCompany: 'Company Info', stepDirectors: 'Directors',
    stepShareholders: 'Shareholders / UBO',
    back: '← Back', next: 'Next →', submit: 'Submit Application',
    submitting: 'Submitting...', addDirector: '+ Add Another Director',
    addShareholder: '+ Add Another Shareholder / UBO',
    remove: 'Remove', required: 'This field is required',
    addBank: '+ Add Another Bank Account', addWallet: '+ Add Another Wallet',
    successIcon: '🎉', successTitle: 'Application Submitted!',
    successMsg: 'Your application has been received and is under review.',
    successId: 'User ID',
    sanctionWarning: '⚠️ We are currently unable to provide services to residents or nationals of this country due to regulatory restrictions.',
    idvNote: '📋 Note: You will receive a separate link to complete Identity Verification (IDV). Please check your email after submission.',
    idvNoteKYB: '📋 Note: Directors and UBOs will receive separate links to complete Identity Verification (IDV) checks via the email addresses provided.',
    uboNote: '👥 Please list all Ultimate Beneficial Owners (UBOs) who directly or indirectly own or control more than 25% of the company.',
    directorEmailNote: '📧 IDV verification link will be sent to this email',
    uploadHint: 'Click to upload (JPG, PNG, PDF, max 5MB)',
    uploading: 'Uploading...', uploaded: 'Uploaded',
    uploadError: 'Upload failed, please try again',
    uploadMore: '+ Upload another file', deleteFile: 'Delete',
    validationError: 'Please fill in all required fields before proceeding.',
    agreementError: 'Please accept all agreements before submitting.',
  },
  zh: {
    kycTitle: 'FinconnectX Platform — 个人开户 (KYC)', kybTitle: 'FinconnectX Platform — 企业开户 (KYB)',
    subtitle: 'FinconnectX Platform',
    stepBasic: '基本信息', stepPersonal: '个人信息',
    stepBusiness: '业务信息', stepBankWallet: '银行 & 钱包',
    stepCompliance: '合规问卷', stepAgreements: '协议签署',
    stepCompany: '公司信息', stepDirectors: '董事信息',
    stepShareholders: '股东 / 最终受益人',
    back: '← 上一步', next: '下一步 →', submit: '提交申请',
    submitting: '提交中...', addDirector: '+ 添加董事',
    addShareholder: '+ 添加股东/UBO',
    remove: '删除', required: '此项为必填项',
    addBank: '+ 添加银行账户', addWallet: '+ 添加钱包',
    successIcon: '🎉', successTitle: '申请已提交！',
    successMsg: '您的申请已收到，正在审核中。', successId: '用户编号',
    sanctionWarning: '⚠️ 由于监管限制，我们目前无法为该国居民或国民提供服务。',
    idvNote: '📋 提示：提交后您将收到一封单独的身份验证（IDV）链接邮件，请查收。',
    idvNoteKYB: '📋 提示：董事和UBO将通过所填写的邮箱地址收到单独的身份验证（IDV）链接。',
    uboNote: '👥 请列出所有直接或间接持有公司25%以上股份的最终受益人（UBO）。',
    directorEmailNote: '📧 IDV验证链接将发送至此邮箱',
    uploadHint: '点击上传（JPG、PNG、PDF，最大5MB）',
    uploading: '上传中...', uploaded: '已上传',
    uploadError: '上传失败，请重试',
    uploadMore: '+ 上传更多文件', deleteFile: '删除',
    validationError: '请填写所有必填项后再继续。',
    agreementError: '请同意所有协议后再提交。',
  }
}

// ─── 样式 ──────────────────────────────────────────────────
const inp = { width: '100%', padding: '9px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', marginTop: '4px', boxSizing: 'border-box', background: '#fff' }
const inpErr = { ...inp, border: '1px solid #f87171' }
const lbl = { fontSize: '14px', fontWeight: '500', color: '#374151', display: 'block', marginBottom: '0' }
const sec = { fontSize: '15px', fontWeight: '600', color: '#111827', marginBottom: '16px', paddingBottom: '8px', borderBottom: '1px solid #e5e7eb' }
const errMsg = { fontSize: '12px', color: '#dc2626', marginTop: '4px' }
const cardStyle = { background: '#f9fafb', borderRadius: '8px', padding: '16px', marginBottom: '16px', border: '1px solid #e5e7eb' }
const removeBtn = { background: 'none', border: '1px solid #fca5a5', borderRadius: '6px', color: '#dc2626', fontSize: '12px', padding: '3px 10px', cursor: 'pointer' }
const addBtn = { width: '100%', padding: '10px', border: '1px dashed #d1d5db', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '14px', color: '#6b7280', marginTop: '8px' }
const noteBox = { background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '8px', padding: '12px 14px', marginBottom: '16px', fontSize: '13px', color: '#1d4ed8', lineHeight: '1.6' }
const warnBox = { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '12px 14px', marginTop: '8px', fontSize: '13px', color: '#dc2626' }

// ─── 组件 ──────────────────────────────────────────────────
function Field({ title, error, hint, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={lbl}>{title}</label>
      {hint && <p style={{ fontSize: '12px', color: '#6b7280', margin: '2px 0 0' }}>{hint}</p>}
      {children}
      {error && <p style={errMsg}>⚠ {error}</p>}
    </div>
  )
}
function Input({ hasError, ...p }) { return <input style={hasError ? inpErr : inp} {...p} /> }
function Sel({ hasError, children, ...p }) { return <select style={hasError ? inpErr : inp} {...p}>{children}</select> }
function Textarea({ hasError, ...p }) { return <textarea style={{ ...(hasError ? inpErr : inp), resize: 'vertical' }} rows={3} {...p} /> }

// 国家下拉（有制裁检测）
function CountrySelect({ value, onChange, name, hasError, sanctionWarning }) {
  const isSanctioned = SANCTIONED_COUNTRIES.includes(value)
  return (
    <div>
      <select value={value} onChange={onChange} name={name} style={hasError ? inpErr : inp}>
        <option value="">Select country</option>
        {ALL_COUNTRIES.map(c => (
          <option key={c} value={c} style={{ color: SANCTIONED_COUNTRIES.includes(c) ? '#dc2626' : 'inherit' }}>
            {c}{SANCTIONED_COUNTRIES.includes(c) ? ' ⚠' : ''}
          </option>
        ))}
      </select>
      {isSanctioned && <div style={warnBox}>{sanctionWarning}</div>}
    </div>
  )
}

// 多文件上传
function MultiUpload({ label, urls, onAdd, onRemove, folder, t, hasError, hint }) {
  const [uploading, setUploading] = useState(false)
  const [uploadErr, setUploadErr] = useState('')
  const handleFile = async (e) => {
    const file = e.target.files[0]; if (!file) return; e.target.value = ''
    if (file.size > 5 * 1024 * 1024) { setUploadErr(t('uploadError')); return }
    setUploading(true); setUploadErr('')
    const ext = file.name.split('.').pop()
    const path = `${folder}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`
    const { error } = await supabase.storage.from('kyc-documents').upload(path, file)
    if (error) { setUploadErr(t('uploadError')); setUploading(false); return }
    const { data } = supabase.storage.from('kyc-documents').getPublicUrl(path)
    onAdd(data.publicUrl); setUploading(false)
  }
  return (
    <div style={{ marginBottom: '14px' }}>
      <p style={{ fontSize: '14px', fontWeight: '500', color: hasError ? '#dc2626' : '#374151', marginBottom: '4px' }}>{label}</p>
      {hint && <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '6px' }}>{hint}</p>}
      {urls.map((url, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '6px', marginBottom: '6px' }}>
          <span>✅</span>
          <a href={url} target="_blank" rel="noreferrer" style={{ fontSize: '13px', color: '#16a34a', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {t('uploaded')} {urls.length > 1 ? `(${i + 1})` : ''}
          </a>
          <button onClick={() => onRemove(i)} style={removeBtn}>{t('deleteFile')}</button>
        </div>
      ))}
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '9px 14px', border: `1px dashed ${hasError ? '#f87171' : '#d1d5db'}`, borderRadius: '8px', cursor: uploading ? 'wait' : 'pointer', fontSize: '13px', color: uploading ? '#2563eb' : '#6b7280', background: uploading ? '#eff6ff' : '#fafafa' }}>
        <span>{uploading ? '⏳' : '📎'}</span>
        <span>{uploading ? t('uploading') : urls.length > 0 ? t('uploadMore') : t('uploadHint')}</span>
        <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={handleFile} disabled={uploading} style={{ display: 'none' }} />
      </label>
      {hasError && urls.length === 0 && <p style={errMsg}>⚠ {t('required')}</p>}
      {uploadErr && <p style={errMsg}>⚠ {uploadErr}</p>}
    </div>
  )
}

function YesNo({ name, value, onChange, details, detailsName, placeholder }) {
  return (
    <div>
      <div style={{ display: 'flex', gap: '16px', marginTop: '6px' }}>
        {['true', 'false'].map(v => (
          <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', cursor: 'pointer' }}>
            <input type="radio" name={name} checked={value === (v === 'true')} onChange={() => onChange(name, v === 'true')} />
            {v === 'true' ? 'Yes' : 'No'}
          </label>
        ))}
      </div>
      {value === true && detailsName && (
        <textarea
          value={details || ''}
          onChange={e => onChange(detailsName, e.target.value)}
          placeholder={placeholder || 'Please provide details...'}
          rows={3}
          style={{ ...inp, resize: 'vertical', marginTop: '8px' }}
        />
      )}
    </div>
  )
}

function SubmitButton({ loading, agreed, onClick, label, loadingLabel }) {
  const disabled = loading || !agreed
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: disabled ? '#9ca3af' : '#10b981', color: '#fff', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '500', transition: 'background .2s' }}>
      {loading ? loadingLabel : label}
    </button>
  )
}

// 银行字段类型
const BANK_FIELDS = [
  { value: 'swift_code', label: 'SWIFT / BIC Code' },
  { value: 'iban', label: 'IBAN (Europe)' },
  { value: 'fps', label: 'FPS (Hong Kong)' },
  { value: 'bsb', label: 'BSB (Australia)' },
  { value: 'aba', label: 'ABA / Routing Number (USA)' },
  { value: 'sort_code', label: 'Sort Code (UK)' },
  { value: 'pix', label: 'PIX (Brazil)' },
  { value: 'transit_number', label: 'Transit Number (Canada)' },
  { value: 'ifsc', label: 'IFSC Code (India)' },
  { value: 'custom', label: 'Other (Custom)' },
]

function BankExtraFields({ bank, index, updateBank }) {
  const fields = bank.extra_fields || []
  const update = (updated) => updateBank(index, { target: { name: 'extra_fields', value: updated } })
  const addField = () => update([...fields, { type: '', custom_label: '', value: '' }])
  const removeField = (fi) => update(fields.filter((_, i) => i !== fi))
  const updateField = (fi, key, val) => update(fields.map((f, i) => i === fi ? { ...f, [key]: val } : f))
  return (
    <div>
      {fields.map((f, fi) => (
        <div key={fi} style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px', marginBottom: '10px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ fontSize: '13px', fontWeight: '500', color: '#6b7280' }}>Field {fi + 1}</span>
            <button onClick={() => removeField(fi)} style={removeBtn}>Remove</button>
          </div>
          <div style={{ marginBottom: '8px' }}>
            <label style={{ fontSize: '13px', color: '#374151', display: 'block', marginBottom: '4px' }}>Field Type</label>
            <select value={f.type} onChange={e => updateField(fi, 'type', e.target.value)} style={inp}>
              <option value="">Select field type</option>
              {BANK_FIELDS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          {f.type === 'custom' && (
            <div style={{ marginBottom: '8px' }}>
              <label style={{ fontSize: '13px', color: '#374151', display: 'block', marginBottom: '4px' }}>Custom Field Name</label>
              <input value={f.custom_label} onChange={e => updateField(fi, 'custom_label', e.target.value)} placeholder="e.g. Bank Code" style={inp} />
            </div>
          )}
          {f.type && (
            <div>
              <label style={{ fontSize: '13px', color: '#374151', display: 'block', marginBottom: '4px' }}>
                {f.type === 'custom' ? (f.custom_label || 'Value') : BANK_FIELDS.find(o => o.value === f.type)?.label}
              </label>
              <input value={f.value} onChange={e => updateField(fi, 'value', e.target.value)} placeholder="Enter value" style={inp} />
            </div>
          )}
        </div>
      ))}
      <button onClick={addField} style={{ width: '100%', padding: '8px', border: '1px dashed #93c5fd', borderRadius: '8px', background: '#eff6ff', cursor: 'pointer', fontSize: '13px', color: '#2563eb', marginBottom: '4px' }}>
        + Add Bank Field (SWIFT / IBAN / FPS / BSB / PIX ...)
      </button>
    </div>
  )
}

// 模板
const emptyPerson = () => ({ full_name: '', nationality: '', email: '', phone: '', address: '', id_type: 'passport', id_number: '', id_expiry_date: '', id_front_urls: [], id_back_urls: [] })
const emptyBank = () => ({ bank_name: '', bank_country: '', account_name: '', account_number: '', currency: '', extra_fields: [] })
const emptyWallet = () => ({ network: '', other_network: '', address: '', label: '' })

// AML 问卷初始状态
const emptyAML = () => ({
  is_licensed: false, license_regulator: '',
  has_aml_program: false, has_aml_program_details: '',
  has_aml_policies: false, has_aml_policies_details: '',
  has_kyc_program: false, kyc_controls: '',
  has_edd: false, edd_procedure: '',
  id_document_timing: '',
  screens_watchlist: false, watchlist_sources: '',
  has_suspicious_monitoring: false, suspicious_threshold: '',
  has_transaction_limits: false, transaction_limits: '',
  requests_sof: false, sof_threshold: '',
  has_high_risk_procedure: false, high_risk_procedure: '',
  prohibits_shell_companies: false, prohibits_shell_details: '',
  has_mlro: false, has_mlro_details: '',
  provides_aml_training: false, training_frequency: '',
  has_independent_audit: false, last_audit_date: '',
  signatory_name: '', signatory_title: '', company_name_cert: '',
})

// 验证
function validateStep(step, isKYC, basic, kyc, kyb, business, banks, wallets) {
  const e = {}
  if (step === 0) {
    if (!basic.email) e.email = true
    if (!basic.phone) e.phone = true
  }
  if (isKYC && step === 1) {
    if (!kyc.full_name) e.full_name = true
    if (!kyc.date_of_birth) e.date_of_birth = true
    if (!kyc.nationality) e.nationality = true
    if (SANCTIONED_COUNTRIES.includes(kyc.nationality)) e.nationality_sanctioned = true
    if (!kyc.country_residence) e.country_residence = true
    if (SANCTIONED_COUNTRIES.includes(kyc.country_residence)) e.residence_sanctioned = true
    if (!kyc.address) e.address = true
    if (!kyc.occupation) e.occupation = true
    if (!kyc.id_number) e.id_number = true
    if (!kyc.id_expiry_date) e.id_expiry_date = true
    if (!kyc.id_front_urls?.length) e.id_front_urls = true
    if (!kyc.id_back_urls?.length) e.id_back_urls = true
    if (!kyc.selfie_urls?.length) e.selfie_urls = true
    if (!kyc.proof_of_address_urls?.length) e.proof_of_address_urls = true
  }
  if (!isKYC && step === 1) {
    if (!kyb.company_name) e.company_name = true
    if (!kyb.registration_number) e.registration_number = true
    if (!kyb.registration_country) e.registration_country = true
    if (!kyb.business_address) e.business_address = true
    if (!kyb.primary_business_nature) e.primary_business_nature = true
    if (!kyb.income_source_type) e.income_source_type = true
    if (kyb.income_source_type === 'others' && !kyb.primary_income_source) e.primary_income_source = true
    if (!kyb.cert_incorporation_urls?.length) e.cert_incorporation_urls = true
    if (!kyb.proof_address_urls?.length) e.proof_address_urls = true
    if (!kyb.bank_statement_urls?.length) e.bank_statement_urls = true
  }
  const bizStep = isKYC ? 2 : 4
  if (step === bizStep) {
    if (!business.business_type) e.business_type = true
    if (business.business_type === 'others' && !business.other_purpose) e.other_purpose = true
    if (!business.trading_experience) e.trading_experience = true
    if (!business.preferred_crypto) e.preferred_crypto = true
    if (business.preferred_crypto === 'others' && !business.other_crypto) e.other_crypto = true
    if (!business.preferred_fiat) e.preferred_fiat = true
    if (business.preferred_fiat === 'others' && !business.other_fiat) e.other_fiat = true
    if (!business.average_trade_size) e.average_trade_size = true
    if (!business.trading_frequency) e.trading_frequency = true
  }
  const bankStep = isKYC ? 3 : 5
  if (step === bankStep) {
    banks.forEach((b, i) => {
      if (!b.bank_name) e[`bank_name_${i}`] = true
      if (!b.bank_country) e[`bank_country_${i}`] = true
      if (!b.account_name) e[`account_name_${i}`] = true
      if (!b.account_number) e[`account_number_${i}`] = true
      if (!b.currency) e[`currency_${i}`] = true
    })
    wallets.forEach((w, i) => {
      if (!w.network) e[`wallet_network_${i}`] = true
      if (w.network === 'others' && !w.other_network) e[`other_network_${i}`] = true
      if (!w.address) e[`wallet_address_${i}`] = true
    })
  }
  return e
}

// ─── 主组件 ────────────────────────────────────────────────
export default function UserRegistration() {
  const [lang, setLang] = useState('en')
  const t = (key) => T[lang][key] || key

  const [step, setStep] = useState(0)
  const [fieldErrors, setFieldErrors] = useState({})
  const fe = fieldErrors
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [createdUserId, setCreatedUserId] = useState(null)

  const [basic, setBasic] = useState({ customer_type: 'individual', email: '', phone: '' })
  const [kyc, setKyc] = useState({
    full_name: '', legal_name: '', date_of_birth: '', nationality: '',
    country_residence: '', address: '', occupation: '', employer: '',
    id_type: 'passport', id_number: '', id_expiry_date: '',
    id_front_urls: [], id_back_urls: [], selfie_urls: [], proof_of_address_urls: []
  })
  const [kyb, setKyb] = useState({
    company_name: '', company_type: '', registration_number: '',
    registration_country: '', registration_date: '', business_address: '',
    website: '', primary_business_nature: '',
    income_source_type: '', primary_income_source: '',
    has_license: false, license_country: '', license_details: '',
    is_financial_institution: null,
    monthly_volume_usd: '', average_ticket_size: '',
    cert_incorporation_urls: [], proof_address_urls: [],
    ownership_structure_urls: [], bank_statement_urls: []
  })
  const [amlForm, setAmlForm] = useState(emptyAML())
  const [directors, setDirectors] = useState([emptyPerson()])
  const [shareholders, setShareholders] = useState([{ ...emptyPerson(), ownership_percentage: '', is_ubo: false }])
  const [business, setBusiness] = useState({
    business_type: '', other_purpose: '', trading_experience: '',
    preferred_crypto: '', other_crypto: '',
    preferred_fiat: '', other_fiat: '',
    average_trade_size: '', trading_frequency: ''
  })
  const [banks, setBanks] = useState([emptyBank()])
  const [wallets, setWallets] = useState([emptyWallet()])
  const [kycCompliance, setKycCompliance] = useState({
    is_pep: false, is_pep_details: '',
    is_sanctions_related: false, is_sanctions_details: '',
    has_finconnectx_dealings: false, finconnectx_details: ''
  })
  const [kybCompliance, setKybCompliance] = useState({
    is_on_sanctions_list: false, is_on_sanctions_list_details: '',
    is_sanctions_country_related: false, is_sanctions_country_details: '',
    is_controlled_by_sanctioned: false, is_controlled_by_sanctioned_details: '',
    has_finconnectx_dealings: false, finconnectx_details: '',
    has_improper_payments: false, has_improper_payments_details: ''
  })
  const [agreements, setAgreements] = useState({
    terms_accepted: false, privacy_accepted: false, unsolicited_request_accepted: false
  })
  const [unsolicitedForm, setUnsolicitedForm] = useState({
    client_full_name: '', contact_date: '', services_requested: ''
  })

  const isKYC = basic.customer_type === 'individual'
  const kycSteps = [t('stepBasic'), t('stepPersonal'), t('stepBusiness'), t('stepBankWallet'), t('stepCompliance'), t('stepAgreements')]
  const kybSteps = [t('stepBasic'), t('stepCompany'), t('stepDirectors'), t('stepShareholders'), t('stepBusiness'), t('stepBankWallet'), t('stepCompliance'), t('stepAgreements')]
  const steps = isKYC ? kycSteps : kybSteps

  const onCh = (setter) => (e) => {
    const { name, value, type, checked } = e.target
    setter(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }))
    setFieldErrors(p => ({ ...p, [name]: false }))
  }
  const onYN = (setter) => (name, value) => setter(p => ({ ...p, [name]: value }))

  const updateDirector = (i, name, value) => setDirectors(p => p.map((d, idx) => idx === i ? { ...d, [name]: value } : d))
  const updateShareholder = (i, name, value) => setShareholders(p => p.map((s, idx) => idx === i ? { ...s, [name]: value } : s))
  const updateBank = (i, e) => {
    const { name, value } = e.target
    setBanks(p => p.map((b, idx) => idx === i ? { ...b, [name]: value } : b))
    setFieldErrors(p => ({ ...p, [`${name}_${i}`]: false }))
  }
  const updateWallet = (i, e) => {
    const { name, value } = e.target
    setWallets(p => p.map((w, idx) => idx === i ? { ...w, [name]: value } : w))
    setFieldErrors(p => ({ ...p, [`${name}_${i}`]: false }))
  }

  const copyFromDirector = (si, di) => {
    const d = directors[di]
    setShareholders(p => p.map((s, i) => i === si ? {
      ...s, full_name: d.full_name, nationality: d.nationality,
      email: d.email, phone: d.phone, address: d.address,
      id_type: d.id_type, id_number: d.id_number, id_expiry_date: d.id_expiry_date,
      id_front_urls: [...(d.id_front_urls || [])], id_back_urls: [...(d.id_back_urls || [])],
      proof_of_address_urls: [...(d.proof_of_address_urls || [])],
    } : s))
  }

  const handleNext = () => {
    const errors = validateStep(step, isKYC, basic, kyc, kyb, business, banks, wallets)
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors); setError(t('validationError'))
      window.scrollTo({ top: 0, behavior: 'smooth' }); return
    }
    setFieldErrors({}); setError(''); setStep(s => s + 1)
  }

 const handleSubmit = async () => {
  if (!agreements.terms_accepted || !agreements.privacy_accepted || !agreements.unsolicited_request_accepted) {
    setError(t('agreementError')); return
  }
  setLoading(true); setError('')
  try {
    // 1. 创建用户主记录（含主联系人）
    const { data: user, error: e1 } = await supabase.from('users')
      .insert({
        customer_type: basic.customer_type,
        email: basic.email,
        phone: basic.phone,
        main_contact_email: basic.customer_type === 'corporate' ? basic.email : null,
        main_contact_phone: basic.customer_type === 'corporate' ? basic.phone : null,
        kyc_status: 'pending', status: 'pending', risk_level: 'low'
      })
      .select().single()
    if (e1) throw e1
    const uid = user.id
    setCreatedUserId(user.user_number_text || uid)

    if (isKYC) {
      // 2a. KYC 个人信息
      const { error: e2 } = await supabase.from('user_kyc_profile').insert({
        user_id: uid,
        full_name: kyc.full_name,
        legal_name: kyc.legal_name || null,
        date_of_birth: kyc.date_of_birth,
        nationality: kyc.nationality,
        country_residence: kyc.country_residence,
        address: kyc.address,
        occupation: kyc.occupation,
        employer: kyc.employer || null,
        id_type: kyc.id_type,
        id_number: kyc.id_number,
        id_expiry_date: kyc.id_expiry_date,
        id_front_url: kyc.id_front_urls[0] || null,
        id_back_url: kyc.id_back_urls[0] || null,
        selfie_url: kyc.selfie_urls[0] || null,
        proof_of_address_url: kyc.proof_of_address_urls[0] || null,
      })
      if (e2) throw e2

      // 2b. KYC 合规问卷
      const { error: e3 } = await supabase.from('kyc_compliance').insert({
        user_id: uid, ...kycCompliance
      })
      if (e3) throw e3

    } else {
      // 3a. KYB 公司信息
      const { error: e2 } = await supabase.from('user_kyb_profile').insert({
        user_id: uid,
        company_name: kyb.company_name,
        company_type: kyb.company_type || null,
        registration_number: kyb.registration_number,
        registration_country: kyb.registration_country,
        registration_date: kyb.registration_date || null,
        business_address: kyb.business_address,
        website: kyb.website || null,
        primary_business_nature: kyb.primary_business_nature,
        primary_income_source: kyb.income_source_type === 'others'
          ? kyb.primary_income_source
          : kyb.income_source_type,
        income_source_type: kyb.income_source_type,
        has_license: kyb.has_license,
        license_details: kyb.license_details || null,
        license_country: kyb.license_country || null,
        is_financial_institution: kyb.is_financial_institution || false,
        monthly_volume_usd: parseFloat(kyb.monthly_volume_usd) || null,
        average_ticket_size: kyb.average_ticket_size || null,
        cert_incorporation_url: kyb.cert_incorporation_urls[0] || null,
        proof_address_url: kyb.proof_address_urls[0] || null,
        ownership_structure_url: kyb.ownership_structure_urls[0] || null,
        bank_statement_url: kyb.bank_statement_urls[0] || null,
        license_cert_url: kyb.license_cert_urls?.[0] || null,
      })
      if (e2) throw e2

      // 3b. 董事信息（含地址证明）
      const { error: e3 } = await supabase.from('kyb_directors').insert(
        directors.map(d => ({
          user_id: uid,
          full_name: d.full_name,
          nationality: d.nationality || null,
          email: d.email || null,
          phone: d.phone || null,
          address: d.address || null,
          id_type: d.id_type,
          id_number: d.id_number || null,
          id_expiry_date: d.id_expiry_date || null,
          id_doc_url: d.id_front_urls?.[0] || null,
          id_back_url: d.id_back_urls?.[0] || null,
          proof_of_address_url: d.proof_of_address_urls?.[0] || null,
        }))
      )
      if (e3) throw e3

      // 3c. 股东/UBO信息（含地址证明）
      const { error: e4 } = await supabase.from('kyb_shareholders').insert(
        shareholders.map(s => ({
          user_id: uid,
          full_name: s.full_name,
          nationality: s.nationality || null,
          email: s.email || null,
          phone: s.phone || null,
          address: s.address || null,
          id_type: s.id_type,
          id_number: s.id_number || null,
          id_expiry_date: s.id_expiry_date || null,
          ownership_percentage: parseFloat(s.ownership_percentage) || null,
          is_ubo: s.is_ubo || false,
          id_doc_url: s.id_front_urls?.[0] || null,
          id_back_url: s.id_back_urls?.[0] || null,
          proof_of_address_url: s.proof_of_address_urls?.[0] || null,
        }))
      )
      if (e4) throw e4

      // 3d. KYB 合规问卷
      const { error: e5 } = await supabase.from('kyb_compliance').insert({
        user_id: uid, ...kybCompliance
      })
      if (e5) throw e5

      // 3e. AML 问卷（仅金融机构）
      if (kyb.is_financial_institution) {
        const { error: e6 } = await supabase.from('kyb_aml_questionnaire').insert({
          user_id: uid,
          is_licensed: amlForm.is_licensed,
          license_regulator: amlForm.license_regulator,
          has_aml_program: amlForm.has_aml_program,
          has_aml_program_details: amlForm.has_aml_program_details,
          has_aml_policies: amlForm.has_aml_policies,
          has_aml_policies_details: amlForm.has_aml_policies_details,
          has_kyc_program: amlForm.has_kyc_program,
          kyc_controls: amlForm.kyc_controls,
          has_edd: amlForm.has_edd,
          edd_procedure: amlForm.edd_procedure,
          id_document_timing: amlForm.id_document_timing,
          screens_watchlist: amlForm.screens_watchlist,
          watchlist_sources: amlForm.watchlist_sources,
          has_suspicious_monitoring: amlForm.has_suspicious_monitoring,
          suspicious_threshold: amlForm.suspicious_threshold,
          has_transaction_limits: amlForm.has_transaction_limits,
          transaction_limits: amlForm.transaction_limits,
          requests_sof: amlForm.requests_sof,
          sof_threshold: amlForm.sof_threshold,
          has_high_risk_procedure: amlForm.has_high_risk_procedure,
          high_risk_procedure: amlForm.high_risk_procedure,
          prohibits_shell_companies: amlForm.prohibits_shell_companies,
          prohibits_shell_details: amlForm.prohibits_shell_details,
          has_mlro: amlForm.has_mlro,
          has_mlro_details: amlForm.has_mlro_details,
          provides_aml_training: amlForm.provides_aml_training,
          training_frequency: amlForm.training_frequency,
          has_independent_audit: amlForm.has_independent_audit,
          last_audit_date: amlForm.last_audit_date,
          signatory_name: amlForm.signatory_name,
          signatory_title: amlForm.signatory_title,
          company_name_cert: amlForm.company_name_cert,
        })
        if (e6) throw e6
      }
    }

    // 4. 业务信息（KYC + KYB 共用）
    const finalPurpose = business.business_type === 'others'
      ? business.other_purpose : business.business_type
    const finalCrypto = business.preferred_crypto === 'others'
      ? business.other_crypto : business.preferred_crypto
    const finalFiat = business.preferred_fiat === 'others'
      ? business.other_fiat : business.preferred_fiat
    const { error: eb } = await supabase.from('user_business_profile').insert({
      user_id: uid,
      business_type: finalPurpose,
      trading_experience: business.trading_experience,
      preferred_crypto: finalCrypto,
      preferred_fiat: finalFiat,
      average_trade_size: business.average_trade_size,
      trading_frequency: business.trading_frequency,
    })
    if (eb) throw eb

    // 5. 银行账户
    for (const b of banks) {
      const extraNotes = (b.extra_fields || [])
        .filter(f => f.type && f.value)
        .map(f => {
          const label = f.type === 'custom'
            ? f.custom_label
            : BANK_FIELDS.find(o => o.value === f.type)?.label || f.type
          return `${label}: ${f.value}`
        }).join(' | ')
      const swiftField = (b.extra_fields || []).find(f => f.type === 'swift_code')
      const ibanField = (b.extra_fields || []).find(f => f.type === 'iban')
      const { error: ew } = await supabase.from('user_bank_accounts').insert({
        user_id: uid,
        bank_name: b.bank_name,
        bank_country: b.bank_country,
        account_name: b.account_name,
        account_number: b.account_number,
        currency: b.currency,
        swift_code: swiftField?.value || null,
        iban: ibanField?.value || null,
        notes: extraNotes || null,
        is_primary: banks.indexOf(b) === 0
      })
      if (ew) throw ew
    }

    // 6. 钱包地址
    for (const w of wallets) {
      if (!w.address) continue
      const finalNetwork = w.network === 'others' ? w.other_network : w.network
      const { error: ewl } = await supabase.from('user_wallets').insert({
        user_id: uid,
        network: finalNetwork,
        address: w.address,
        label: w.label || null,
        is_primary: wallets.indexOf(w) === 0
      })
      if (ewl) throw ewl
    }

    // 7. 协议签署（含 Unsolicited Confirmation 签字信息）
    const now = new Date().toISOString()
    const { error: ea } = await supabase.from('user_agreements').insert({
      user_id: uid,
      terms_accepted: true,
      terms_accepted_at: now,
      privacy_accepted: true,
      privacy_accepted_at: now,
      unsolicited_request_accepted: true,
      unsolicited_request_at: now,
      unsolicited_client_name: unsolicitedForm.client_full_name || null,
      unsolicited_contact_date: unsolicitedForm.contact_date || null,
      unsolicited_services: unsolicitedForm.services_requested || null,
    })
    if (ea) throw ea

    setStep(steps.length)
  } catch (err) {
    setError(`Error: ${err.message}`)
  } finally {
    setLoading(false)
  }
}

  // ─── 渲染各步骤 ───────────────────────────────────────────

const renderStep0 = () => (
  <div>
    <p style={sec}>Basic Information</p>
    <Field title="Customer Type">
      <Sel name="customer_type" value={basic.customer_type} onChange={onCh(setBasic)}>
        <option value="individual">Individual (KYC)</option>
        <option value="corporate">Corporate (KYB)</option>
      </Sel>
    </Field>

    {basic.customer_type === 'individual' ? (
      <>
        <Field title="Email Address *" error={fe.email && t('required')}>
          <Input type="email" name="email" value={basic.email} onChange={onCh(setBasic)} placeholder="example@email.com" hasError={fe.email} />
        </Field>
        <Field title="Phone Number *" error={fe.phone && t('required')}>
          <Input type="tel" name="phone" value={basic.phone} onChange={onCh(setBasic)} placeholder="+1 234 567 8900" hasError={fe.phone} />
        </Field>
      </>
    ) : (
      <>
        <div style={{ background: '#f5f0ff', borderRadius: '8px', padding: '16px', border: '1px solid #d8b4fe', marginBottom: '4px' }}>
          <p style={{ fontSize: '13px', fontWeight: '600', color: '#6b2fa0', marginBottom: '6px' }}>
            Main Contact Person
          </p>
          <p style={{ fontSize: '12px', color: '#7c3aed', marginBottom: '12px', lineHeight: '1.6' }}>
            Please provide the primary contact person for this application. This person will be the main point of contact for all communications regarding this account.
          </p>
          <Field title="Main Contact Email *" error={fe.email && t('required')}>
            <Input type="email" name="email" value={basic.email} onChange={onCh(setBasic)} placeholder="main.contact@company.com" hasError={fe.email} />
          </Field>
          <Field title="Main Contact Phone *" error={fe.phone && t('required')}>
            <Input type="tel" name="phone" value={basic.phone} onChange={onCh(setBasic)} placeholder="+1 234 567 8900" hasError={fe.phone} />
          </Field>
        </div>
      </>
    )}
  </div>
)

  const renderKYCStep1 = () => (
    <div>
      <p style={sec}>Personal Information</p>
      <Field title="Full Name *" error={fe.full_name && t('required')}>
        <Input name="full_name" value={kyc.full_name} onChange={onCh(setKyc)} placeholder="As shown on ID" hasError={fe.full_name} />
      </Field>
      <Field title="Legal Name (as shown on Certificate / ID)" hint="If different from above">
        <Input name="legal_name" value={kyc.legal_name} onChange={onCh(setKyc)} placeholder="Legal name on official documents" />
      </Field>
      <Field title="Date of Birth *" error={fe.date_of_birth && t('required')}>
        <Input type="date" name="date_of_birth" value={kyc.date_of_birth} onChange={onCh(setKyc)} hasError={fe.date_of_birth} />
      </Field>
      <Field title="Nationality *" error={(fe.nationality || fe.nationality_sanctioned) && (fe.nationality_sanctioned ? '' : t('required'))}>
        <CountrySelect name="nationality" value={kyc.nationality}
          onChange={e => { onCh(setKyc)(e); setFieldErrors(p => ({ ...p, nationality: false, nationality_sanctioned: false })) }}
          hasError={fe.nationality || fe.nationality_sanctioned}
          sanctionWarning={t('sanctionWarning')} />
        {fe.nationality_sanctioned && <div style={warnBox}>{t('sanctionWarning')}</div>}
      </Field>
      <Field title="Country of Residence *" error={(fe.country_residence || fe.residence_sanctioned) && (fe.residence_sanctioned ? '' : t('required'))}>
        <CountrySelect name="country_residence" value={kyc.country_residence}
          onChange={e => { onCh(setKyc)(e); setFieldErrors(p => ({ ...p, country_residence: false, residence_sanctioned: false })) }}
          hasError={fe.country_residence || fe.residence_sanctioned}
          sanctionWarning={t('sanctionWarning')} />
        {fe.residence_sanctioned && <div style={warnBox}>{t('sanctionWarning')}</div>}
      </Field>
      <Field title="Residential Address *" error={fe.address && t('required')}>
        <Input name="address" value={kyc.address} onChange={onCh(setKyc)} placeholder="Full address" hasError={fe.address} />
      </Field>
      <Field title="Occupation *" error={fe.occupation && t('required')}>
        <Input name="occupation" value={kyc.occupation} onChange={onCh(setKyc)} placeholder="e.g. Engineer, Investor" hasError={fe.occupation} />
      </Field>
      <Field title="Employer">
        <Input name="employer" value={kyc.employer} onChange={onCh(setKyc)} placeholder="Company name (if employed)" />
      </Field>
      <Field title="ID Type *">
        <Sel name="id_type" value={kyc.id_type} onChange={onCh(setKyc)}>
          <option value="passport">Passport</option>
          <option value="national_id">National ID</option>
          <option value="driving_license">Driving License</option>
        </Sel>
      </Field>
      <Field title="ID Number *" error={fe.id_number && t('required')}>
        <Input name="id_number" value={kyc.id_number} onChange={onCh(setKyc)} hasError={fe.id_number} />
      </Field>
      <Field title="ID Expiry Date *" error={fe.id_expiry_date && t('required')}>
        <Input type="date" name="id_expiry_date" value={kyc.id_expiry_date} onChange={onCh(setKyc)} hasError={fe.id_expiry_date} />
      </Field>
      <MultiUpload label="ID Front Photo *" urls={kyc.id_front_urls} folder="kyc" t={t} hasError={fe.id_front_urls}
        onAdd={url => { setKyc(p => ({ ...p, id_front_urls: [...p.id_front_urls, url] })); setFieldErrors(p => ({ ...p, id_front_urls: false })) }}
        onRemove={i => setKyc(p => ({ ...p, id_front_urls: p.id_front_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="ID Back Photo *" urls={kyc.id_back_urls} folder="kyc" t={t} hasError={fe.id_back_urls}
        onAdd={url => { setKyc(p => ({ ...p, id_back_urls: [...p.id_back_urls, url] })); setFieldErrors(p => ({ ...p, id_back_urls: false })) }}
        onRemove={i => setKyc(p => ({ ...p, id_back_urls: p.id_back_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="Selfie with ID *" urls={kyc.selfie_urls} folder="kyc" t={t} hasError={fe.selfie_urls}
        onAdd={url => { setKyc(p => ({ ...p, selfie_urls: [...p.selfie_urls, url] })); setFieldErrors(p => ({ ...p, selfie_urls: false })) }}
        onRemove={i => setKyc(p => ({ ...p, selfie_urls: p.selfie_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="Proof of Address *" hint="e.g. utility bill, bank statement (within 3 months)"
        urls={kyc.proof_of_address_urls} folder="kyc" t={t} hasError={fe.proof_of_address_urls}
        onAdd={url => { setKyc(p => ({ ...p, proof_of_address_urls: [...p.proof_of_address_urls, url] })); setFieldErrors(p => ({ ...p, proof_of_address_urls: false })) }}
        onRemove={i => setKyc(p => ({ ...p, proof_of_address_urls: p.proof_of_address_urls.filter((_, idx) => idx !== i) }))} />
    </div>
  )

  const renderKYBStep1 = () => (
    <div>
      <p style={sec}>Company Information</p>
      <Field title="Company Name *" error={fe.company_name && t('required')}>
        <Input name="company_name" value={kyb.company_name} onChange={onCh(setKyb)} placeholder="Legal company name" hasError={fe.company_name} />
      </Field>
      <Field title="Company Type">
        <Sel name="company_type" value={kyb.company_type} onChange={onCh(setKyb)}>
          <option value="">Select type</option>
          {['LLC', 'Ltd', 'Corp', 'Partnership', 'Other'].map(v => <option key={v} value={v}>{v}</option>)}
        </Sel>
      </Field>
      <Field title="Registration Number *" error={fe.registration_number && t('required')}>
        <Input name="registration_number" value={kyb.registration_number} onChange={onCh(setKyb)} hasError={fe.registration_number} />
      </Field>
      <Field title="Country of Registration *" error={fe.registration_country && t('required')}>
        <CountrySelect name="registration_country" value={kyb.registration_country}
          onChange={onCh(setKyb)} hasError={fe.registration_country} sanctionWarning={t('sanctionWarning')} />
      </Field>
      <Field title="Registration Date">
        <Input type="date" name="registration_date" value={kyb.registration_date} onChange={onCh(setKyb)} />
      </Field>
      <Field title="Business Address *" error={fe.business_address && t('required')}>
        <Input name="business_address" value={kyb.business_address} onChange={onCh(setKyb)} hasError={fe.business_address} />
      </Field>
      <Field title="Website (if any)">
        <Input name="website" value={kyb.website} onChange={onCh(setKyb)} placeholder="https://www.example.com" />
      </Field>
      <Field title="Primary Business Nature *" error={fe.primary_business_nature && t('required')}>
        <Textarea name="primary_business_nature" value={kyb.primary_business_nature} onChange={onCh(setKyb)} hasError={fe.primary_business_nature} />
      </Field>

      {/* 主要收入来源 - 下拉菜单 */}
      <Field title="Primary Source of Income *" error={fe.income_source_type && t('required')}>
        <Sel name="income_source_type" value={kyb.income_source_type} onChange={onCh(setKyb)} hasError={fe.income_source_type}>
          <option value="">Select source</option>
          <option value="investment">Investment</option>
          <option value="salary">Salary / Employment Income</option>
          <option value="savings">Savings</option>
          <option value="pension">Pension Releases</option>
          <option value="share_sales">Share Sales and Dividends</option>
          <option value="inheritance">Inheritances</option>
          <option value="business_revenue">Business Revenue</option>
          <option value="property">Property / Real Estate</option>
          <option value="others">Others</option>
        </Sel>
      </Field>
      {kyb.income_source_type === 'others' && (
        <Field title="Please specify *" error={fe.primary_income_source && t('required')}>
          <Input name="primary_income_source" value={kyb.primary_income_source} onChange={onCh(setKyb)} placeholder="Please describe the primary income source" hasError={fe.primary_income_source} />
        </Field>
      )}

      <Field title="Monthly Transaction Volume (USD)">
        <Input type="number" name="monthly_volume_usd" value={kyb.monthly_volume_usd} onChange={onCh(setKyb)} placeholder="e.g. 500000" />
      </Field>
      <Field title="Average Ticket Size">
        <Sel name="average_ticket_size" value={kyb.average_ticket_size} onChange={onCh(setKyb)}>
          <option value="">Select range</option>
          <option value="<10000">Under $10,000</option>
          <option value="10000-50000">$10,000 - $50,000</option>
          <option value="50000-200000">$50,000 - $200,000</option>
          <option value=">200000">Above $200,000</option>
        </Sel>
      </Field>

      {/* 牌照 - 先问是否有 */}
      <div style={{ marginBottom: '14px' }}>
        <p style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
          Does the company hold any regulatory license?
        </p>
        <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
          {['Yes', 'No'].map(v => (
            <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="radio" checked={kyb.has_license === (v === 'Yes')}
                onChange={() => setKyb(p => ({ ...p, has_license: v === 'Yes' }))} />
              {v}
            </label>
          ))}
        </div>
        {kyb.has_license && (
          <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '14px', border: '1px solid #e5e7eb' }}>
            <Field title="License Details (License type, issuing authority, license number)">
              <Textarea name="license_details" value={kyb.license_details} onChange={onCh(setKyb)} placeholder="e.g. Money Service Business License, AUSTRAC, MSB12345678" />
            </Field>
            <Field title="Country of License">
              <CountrySelect name="license_country" value={kyb.license_country} onChange={onCh(setKyb)} sanctionWarning={t('sanctionWarning')} />
            </Field>

            {/* 是否是金融机构 */}
            <div style={{ marginTop: '8px' }}>
              <p style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px' }}>
                Is this a financial institution related license?
              </p>
              <div style={{ display: 'flex', gap: '16px', marginBottom: '8px' }}>
                {['Yes', 'No'].map(v => (
                  <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', cursor: 'pointer' }}>
                    <input type="radio" 
                      checked={v === 'Yes' ? kyb.is_financial_institution === true : kyb.is_financial_institution === false}
                      onChange={() => setKyb(p => ({ ...p, is_financial_institution: v === 'Yes' }))} />
                    {v}
                  </label>
                ))}
              </div>
                {kyb.is_financial_institution === true && (
                <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '10px 12px', fontSize: '13px', color: '#1d4ed8' }}>
                  📋 As a licensed financial institution, you will also need to complete an AML Questionnaire in the next steps.
                </div>
              )}
            </div>

            {/* License Certificate 上传 - 只要有 license 就显示 */}
            <MultiUpload label="License Certificate *" urls={kyb.license_cert_urls || []} folder="kyb" t={t}
              onAdd={url => setKyb(p => ({ ...p, license_cert_urls: [...(p.license_cert_urls || []), url] }))}
              onRemove={i => setKyb(p => ({ ...p, license_cert_urls: (p.license_cert_urls || []).filter((_, idx) => idx !== i) }))} />
          </div>
        )}
        </div>

      <MultiUpload label="Certificate of Incorporation *" urls={kyb.cert_incorporation_urls} folder="kyb" t={t} hasError={fe.cert_incorporation_urls}
        onAdd={url => { setKyb(p => ({ ...p, cert_incorporation_urls: [...p.cert_incorporation_urls, url] })); setFieldErrors(p => ({ ...p, cert_incorporation_urls: false })) }}
        onRemove={i => setKyb(p => ({ ...p, cert_incorporation_urls: p.cert_incorporation_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="Proof of Address *" urls={kyb.proof_address_urls} folder="kyb" t={t} hasError={fe.proof_address_urls}
        onAdd={url => { setKyb(p => ({ ...p, proof_address_urls: [...p.proof_address_urls, url] })); setFieldErrors(p => ({ ...p, proof_address_urls: false })) }}
        onRemove={i => setKyb(p => ({ ...p, proof_address_urls: p.proof_address_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="Ownership Structure Document" urls={kyb.ownership_structure_urls} folder="kyb" t={t}
        onAdd={url => setKyb(p => ({ ...p, ownership_structure_urls: [...p.ownership_structure_urls, url] }))}
        onRemove={i => setKyb(p => ({ ...p, ownership_structure_urls: p.ownership_structure_urls.filter((_, idx) => idx !== i) }))} />
      <MultiUpload label="Recent Bank Statement * (within 3 months)" urls={kyb.bank_statement_urls} folder="kyb" t={t} hasError={fe.bank_statement_urls}
        onAdd={url => { setKyb(p => ({ ...p, bank_statement_urls: [...p.bank_statement_urls, url] })); setFieldErrors(p => ({ ...p, bank_statement_urls: false })) }}
        onRemove={i => setKyb(p => ({ ...p, bank_statement_urls: p.bank_statement_urls.filter((_, idx) => idx !== i) }))} />

    </div>
  )

  // AML 问卷（金融机构专用）
  const renderAMLQuestionnaire = () => (
    <div style={{ marginTop: '24px' }}>
      <p style={{ ...sec, color: '#1d4ed8' }}>AML Questionnaire (Financial Institution)</p>
      <div style={noteBox}>
        This section is required for licensed financial institutions. Please answer all questions accurately.
      </div>

      {[
        { label: 'Is your company licensed to perform the business as described above? If yes, please specify which government agency regulates your business.', key: 'is_licensed', detailKey: 'license_regulator', placeholder: 'Please specify the regulating agency' },
        { label: 'Does the law in your jurisdiction require your firm to have an AML compliance program?', key: 'has_aml_program', detailKey: 'has_aml_program_details', placeholder: 'Please provide details...' },
        { label: 'Does your company have policies and procedures to combat Money Laundering and Terrorist Financing?', key: 'has_aml_policies',detailKey: 'has_aml_policies_details', placeholder: 'Please provide details...'  },
        { label: 'Has your company implemented a Know-Your-Customer (KYC) program? If yes, please specify the controls.', key: 'has_kyc_program', detailKey: 'kyc_controls', placeholder: 'Describe your KYC controls' },
        { label: 'Has your company implemented Enhanced Due Diligence (EDD)? If yes, please specify the procedure.', key: 'has_edd', detailKey: 'edd_procedure', placeholder: 'Describe your EDD procedure' },
        { label: 'Does your company screen customer accounts and fund transfers for watchlist names? If yes, please indicate the databases used (e.g. US-OFAC).', key: 'screens_watchlist', detailKey: 'watchlist_sources', placeholder: 'e.g. US-OFAC, UN Sanctions List' },
        { label: 'Does your company have a system for monitoring and detecting suspicious transactions and reporting to authorities? If yes, specify the amount threshold.', key: 'has_suspicious_monitoring', detailKey: 'suspicious_threshold', placeholder: 'e.g. Transactions above $10,000 USD' },
        { label: 'Does your company have maximum transaction limits? If yes, please provide the limit(s).', key: 'has_transaction_limits', detailKey: 'transaction_limits', placeholder: 'e.g. $50,000 per transaction' },
        { label: 'Is a Source of Funds (SOF) form requested from clients? If yes, specify the amount threshold.', key: 'requests_sof', detailKey: 'sof_threshold', placeholder: 'e.g. Required for transactions above $5,000' },
        { label: 'Is there any special procedure for high-risk customers? If yes, please describe briefly.', key: 'has_high_risk_procedure', detailKey: 'high_risk_procedure', placeholder: 'Describe your high-risk customer procedure' },
        { label: 'Does your company prohibit any form of business with "Shell" companies?', key: 'prohibits_shell_companies',detailKey: 'prohibits_shell_details', placeholder: 'Please provide details...'  },
        { label: 'Does your company have a Money Laundering Reporting Officer (MLRO) or equivalent?', key: 'has_mlro',detailKey: 'has_mlro_details', placeholder: 'Please provide the name and contact of your MLRO...' },
        { label: 'Does your company provide employee training related to AML and Terrorist Financing prevention? If yes, state frequency.', key: 'provides_aml_training', detailKey: 'training_frequency', placeholder: 'e.g. Annually, Semi-annually' },
        { label: 'Does your company have policies for an independent audit of AML compliance? If yes, when was the last review?', key: 'has_independent_audit', detailKey: 'last_audit_date', placeholder: 'e.g. January 2024' },
      ].map(({ label, key, detailKey, placeholder }) => (
        <div key={key} style={{ marginBottom: '20px', padding: '14px', background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
          <p style={{ fontSize: '13px', fontWeight: '500', color: '#374151', marginBottom: '8px', lineHeight: '1.6' }}>{label}</p>
          <YesNo name={key} value={amlForm[key]} onChange={(n, v) => setAmlForm(p => ({ ...p, [n]: v }))}
            details={detailKey ? amlForm[detailKey] : ''} detailsName={detailKey || ''}
            placeholder={placeholder || 'Please provide details...'} />
        </div>
      ))}

      <div style={{ marginTop: '16px', padding: '16px', background: '#fef9c3', borderRadius: '8px', border: '1px solid #fde047' }}>
        <p style={{ fontSize: '13px', fontWeight: '600', color: '#854d0e', marginBottom: '12px' }}>Certification</p>
        <p style={{ fontSize: '12px', color: '#92400e', marginBottom: '12px', lineHeight: '1.6' }}>
          I certify that I have read and understood this questionnaire, that the statements made herein are complete and correct, and that I am authorized to execute this questionnaire on behalf of the company.
        </p>
        <Field title="Signatory Full Name *">
          <Input name="signatory_name" value={amlForm.signatory_name} onChange={e => setAmlForm(p => ({ ...p, signatory_name: e.target.value }))} placeholder="Full name" />
        </Field>
        <Field title="Title / Position *">
          <Input name="signatory_title" value={amlForm.signatory_title} onChange={e => setAmlForm(p => ({ ...p, signatory_title: e.target.value }))} placeholder="e.g. Director, Compliance Officer" />
        </Field>
        <Field title="Company Name *">
          <Input name="company_name_cert" value={amlForm.company_name_cert} onChange={e => setAmlForm(p => ({ ...p, company_name_cert: e.target.value }))} placeholder="Legal company name" />
        </Field>
      </div>
    </div>
  )

  const renderPersonCard = (person, index, updateFn, removeFn, labelKey, canRemove, showCopy, isUBOSection = false) => (
    <div key={index} style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <p style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', margin: 0 }}>
          {labelKey} {index + 1}{isUBOSection && person.is_ubo ? ' 👑 UBO' : ''}
        </p>
        {canRemove && <button onClick={() => removeFn(index)} style={removeBtn}>{t('remove')}</button>}
      </div>

      {showCopy && directors.length > 0 && (
        <div style={{ background: '#eff6ff', borderRadius: '6px', padding: '10px 12px', marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', color: '#2563eb', fontWeight: '500' }}>Same as Director:</span>
          <select onChange={e => { if (e.target.value !== '') copyFromDirector(index, parseInt(e.target.value)); e.target.value = '' }} defaultValue=""
            style={{ fontSize: '13px', padding: '4px 8px', borderRadius: '6px', border: '1px solid #93c5fd', background: '#fff', color: '#1d4ed8', cursor: 'pointer' }}>
            <option value="">Select director to copy from</option>
            {directors.map((d, i) => <option key={i} value={i}>Director {i + 1}{d.full_name ? ` — ${d.full_name}` : ''}</option>)}
          </select>
        </div>
      )}

      <Field title="Full Name *"><Input name="full_name" value={person.full_name} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <Field title="Nationality"><Input name="nationality" value={person.nationality} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <Field title={`Email * ${t('directorEmailNote')}`}>
        <Input type="email" name="email" value={person.email} onChange={e => updateFn(index, e.target.name, e.target.value)} placeholder="email@example.com" />
        <p style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>📧 {t('directorEmailNote')}</p>
      </Field>
      <Field title="Phone"><Input name="phone" value={person.phone} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <Field title="Address"><Input name="address" value={person.address} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <Field title="ID Type">
        <Sel name="id_type" value={person.id_type} onChange={e => updateFn(index, e.target.name, e.target.value)}>
          <option value="passport">Passport</option>
          <option value="national_id">National ID</option>
          <option value="driving_license">Driving License</option>
        </Sel>
      </Field>
      <Field title="ID Number"><Input name="id_number" value={person.id_number} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <Field title="ID Expiry Date"><Input type="date" name="id_expiry_date" value={person.id_expiry_date} onChange={e => updateFn(index, e.target.name, e.target.value)} /></Field>
      <MultiUpload label="ID Front *" urls={person.id_front_urls || []} folder="kyb-persons" t={t}
        onAdd={url => updateFn(index, 'id_front_urls', [...(person.id_front_urls || []), url])}
        onRemove={i => updateFn(index, 'id_front_urls', (person.id_front_urls || []).filter((_, idx) => idx !== i))} />
      <MultiUpload label="ID Back *" urls={person.id_back_urls || []} folder="kyb-persons" t={t}
        onAdd={url => updateFn(index, 'id_back_urls', [...(person.id_back_urls || []), url])}
        onRemove={i => updateFn(index, 'id_back_urls', (person.id_back_urls || []).filter((_, idx) => idx !== i))} />
      <MultiUpload label="Proof of Address *" hint="e.g. utility bill, bank statement (within 3 months)"
        urls={person.proof_of_address_urls || []} folder="kyb-persons" t={t}
        onAdd={url => updateFn(index, 'proof_of_address_urls', [...(person.proof_of_address_urls || []), url])}
        onRemove={i => updateFn(index, 'proof_of_address_urls', (person.proof_of_address_urls || []).filter((_, idx) => idx !== i))} />
    </div>
  )

  const renderKYBStep2 = () => (
    <div>
      <p style={sec}>Director Information</p>
      {directors.map((d, i) => renderPersonCard(d, i, updateDirector, (i) => setDirectors(p => p.filter((_, idx) => idx !== i)), 'Director', directors.length > 1, false))}
      <button onClick={() => setDirectors(p => [...p, emptyPerson()])} style={addBtn}>{t('addDirector')}</button>
    </div>
  )

  const renderKYBStep3 = () => (
    <div>
      <p style={sec}>Shareholders / UBO Information</p>
      <div style={noteBox}>{t('uboNote')}</div>
      {shareholders.map((s, i) => (
        <div key={i}>
          {renderPersonCard(s, i, updateShareholder, (i) => setShareholders(p => p.filter((_, idx) => idx !== i)), 'Shareholder / UBO', shareholders.length > 1, true, true)}
          <div style={{ marginTop: '-8px', marginBottom: '16px', padding: '0 4px' }}>
            <Field title="Ownership Percentage (%) *">
              <Input type="number" name="ownership_percentage" value={s.ownership_percentage}
                onChange={e => updateShareholder(i, e.target.name, e.target.value)} placeholder="e.g. 25" />
            </Field>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={s.is_ubo} onChange={e => updateShareholder(i, 'is_ubo', e.target.checked)} />
              This person is a Ultimate Beneficial Owner (UBO) with more than 25% ownership
            </label>
          </div>
        </div>
      ))}
      <button onClick={() => setShareholders(p => [...p, { ...emptyPerson(), ownership_percentage: '', is_ubo: false }])} style={addBtn}>{t('addShareholder')}</button>
    </div>
  )

  const renderBusinessStep = () => (
    <div>
      <p style={sec}>Business Information</p>
      <Field title="Trade Purpose *" error={fe.business_type && t('required')}>
        <Sel name="business_type" value={business.business_type} onChange={onCh(setBusiness)} hasError={fe.business_type}>
          <option value="">Select purpose</option>
          <option value="investment">Investment</option>
          <option value="remittance">Remittance</option>
          <option value="hedging">Hedging</option>
          <option value="payments">Payments</option>
          <option value="trading">Trading</option>
          <option value="others">Others</option>
        </Sel>
      </Field>
      {business.business_type === 'others' && (
        <Field title="Please specify *" error={fe.other_purpose && t('required')}>
          <Input name="other_purpose" value={business.other_purpose} onChange={onCh(setBusiness)} hasError={fe.other_purpose} />
        </Field>
      )}
      <Field title="Trading Experience *" error={fe.trading_experience && t('required')}>
        <Sel name="trading_experience" value={business.trading_experience} onChange={onCh(setBusiness)} hasError={fe.trading_experience}>
          <option value="">Select</option>
          <option value="beginner">Beginner (less than 1 year)</option>
          <option value="intermediate">Intermediate (1-3 years)</option>
          <option value="experienced">Experienced (3+ years)</option>
        </Sel>
      </Field>
      <Field title="Preferred Cryptocurrency *" error={fe.preferred_crypto && t('required')}>
        <Sel name="preferred_crypto" value={business.preferred_crypto} onChange={onCh(setBusiness)} hasError={fe.preferred_crypto}>
          <option value="">Select</option>
          <option value="USDT">USDT</option>
          <option value="USDC">USDC</option>
          <option value="BTC">BTC</option>
          <option value="ETH">ETH</option>
          <option value="others">Others</option>
        </Sel>
      </Field>
      {business.preferred_crypto === 'others' && (
        <Field title="Please specify *" error={fe.other_crypto && t('required')}>
          <Input name="other_crypto" value={business.other_crypto} onChange={onCh(setBusiness)} hasError={fe.other_crypto} />
        </Field>
      )}
      <Field title="Preferred Fiat Currency *" error={fe.preferred_fiat && t('required')}>
        <Sel name="preferred_fiat" value={business.preferred_fiat} onChange={onCh(setBusiness)} hasError={fe.preferred_fiat}>
          <option value="">Select</option>
          {['USD', 'EUR', 'GBP', 'AUD', 'HKD', 'SGD', 'CAD'].map(v => <option key={v} value={v}>{v}</option>)}
          <option value="others">Others</option>
        </Sel>
      </Field>
      {business.preferred_fiat === 'others' && (
        <Field title="Please specify *" error={fe.other_fiat && t('required')}>
          <Input name="other_fiat" value={business.other_fiat} onChange={onCh(setBusiness)} hasError={fe.other_fiat} />
        </Field>
      )}
      <Field title="Average Trade Size (USD) *" error={fe.average_trade_size && t('required')}>
        <Sel name="average_trade_size" value={business.average_trade_size} onChange={onCh(setBusiness)} hasError={fe.average_trade_size}>
          <option value="">Select</option>
          <option value="<10000">Under $10,000</option>
          <option value="10000-30000">$10,000 - $30,000</option>
          <option value="30000-50000">$30,000 - $50,000</option>
          <option value="50000-100000">$50,000 - $100,000</option>
          <option value="100000-200000">$100,000 - $200,000</option>
          <option value=">200000">Above $200,000</option>
        </Sel>
      </Field>
      <Field title="Trading Frequency *" error={fe.trading_frequency && t('required')}>
        <Sel name="trading_frequency" value={business.trading_frequency} onChange={onCh(setBusiness)} hasError={fe.trading_frequency}>
          <option value="">Select</option>
          <option value="more_than_monthly">More than monthly</option>
          <option value="monthly">Monthly</option>
          <option value="weekly">Weekly</option>
          <option value="daily">Daily</option>
        </Sel>
      </Field>

      {/* KYB 金融机构 AML 问卷 */}
      {!isKYC && kyb.is_financial_institution && renderAMLQuestionnaire()}
    </div>
  )

  const renderBankWalletStep = () => (
    <div>
      <p style={sec}>Bank Account(s)</p>
      {banks.map((b, i) => (
        <div key={i} style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <p style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', margin: 0 }}>Bank Account {i + 1}</p>
            {banks.length > 1 && <button onClick={() => setBanks(p => p.filter((_, idx) => idx !== i))} style={removeBtn}>{t('remove')}</button>}
          </div>
          <Field title="Bank Name *" error={fe[`bank_name_${i}`] && t('required')}>
            <Input name="bank_name" value={b.bank_name} onChange={e => updateBank(i, e)} placeholder="e.g. HSBC, DBS" hasError={fe[`bank_name_${i}`]} />
          </Field>
          <Field title="Bank Country *" error={fe[`bank_country_${i}`] && t('required')}>
            <Input name="bank_country" value={b.bank_country} onChange={e => updateBank(i, e)} hasError={fe[`bank_country_${i}`]} />
          </Field>
          <Field title="Account Holder Name *" error={fe[`account_name_${i}`] && t('required')}>
            <Input name="account_name" value={b.account_name} onChange={e => updateBank(i, e)} hasError={fe[`account_name_${i}`]} />
          </Field>
          <Field title="Account Number *" error={fe[`account_number_${i}`] && t('required')}>
            <Input name="account_number" value={b.account_number} onChange={e => updateBank(i, e)} hasError={fe[`account_number_${i}`]} />
          </Field>
          <Field title="Currency *" error={fe[`currency_${i}`] && t('required')}>
            <Sel name="currency" value={b.currency} onChange={e => updateBank(i, e)} hasError={fe[`currency_${i}`]}>
              <option value="">Select</option>
              {['USD', 'EUR', 'GBP', 'AUD', 'HKD', 'SGD', 'CAD'].map(v => <option key={v} value={v}>{v}</option>)}
            </Sel>
          </Field>
          <BankExtraFields bank={b} index={i} updateBank={updateBank} />
        </div>
      ))}
      <button onClick={() => setBanks(p => [...p, emptyBank()])} style={addBtn}>{t('addBank')}</button>

      <p style={{ ...sec, marginTop: '28px' }}>Crypto Wallet(s)</p>
      {wallets.map((w, i) => (
        <div key={i} style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <p style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', margin: 0 }}>Wallet {i + 1}</p>
            {wallets.length > 1 && <button onClick={() => setWallets(p => p.filter((_, idx) => idx !== i))} style={removeBtn}>{t('remove')}</button>}
          </div>
          <Field title="Network *" error={fe[`wallet_network_${i}`] && t('required')}>
            <Sel name="network" value={w.network} onChange={e => updateWallet(i, e)} hasError={fe[`wallet_network_${i}`]}>
              <option value="">Select network</option>
              <option value="Bitcoin">Bitcoin</option>
              <option value="Ethereum (ERC20)">Ethereum (ERC20)</option>
              <option value="Tron (TRC20)">Tron (TRC20)</option>
              <option value="BNB Chain (BEP20)">BNB Chain (BEP20)</option>
              <option value="Solana">Solana</option>
              <option value="Polygon">Polygon</option>
              <option value="others">Others</option>
            </Sel>
          </Field>
          {w.network === 'others' && (
            <Field title="Please specify network *" error={fe[`other_network_${i}`] && t('required')}>
              <Input name="other_network" value={w.other_network} onChange={e => updateWallet(i, e)} hasError={fe[`other_network_${i}`]} />
            </Field>
          )}
          <Field title="Wallet Address *" error={fe[`wallet_address_${i}`] && t('required')}>
            <Input name="address" value={w.address} onChange={e => updateWallet(i, e)} placeholder="0x..." hasError={fe[`wallet_address_${i}`]} />
          </Field>
          <Field title="Label">
            <Input name="label" value={w.label} onChange={e => updateWallet(i, e)} placeholder="e.g. My Main Wallet" />
          </Field>
        </div>
      ))}
      <button onClick={() => setWallets(p => [...p, emptyWallet()])} style={addBtn}>{t('addWallet')}</button>
    </div>
  )

  const renderKYCCompliance = () => (
    <div>
      <p style={sec}>Compliance Questionnaire</p>
      {[
        { key: 'is_pep', detailKey: 'is_pep_details', q: 'Q1. Are you listed as a PEP (Politically Exposed Person) in any countries?', ph: 'Please provide details of your PEP status...' },
        { key: 'is_sanctions_related', detailKey: 'is_sanctions_details', q: 'Q2. Are you the officer, director, direct or indirect shareholder or ultimate actual beneficiary of any companies that are involved under the laws of any country, region or territory that is the target of comprehensive, country or territory-wide Sanctions?', ph: 'Please provide details...' },
        { key: 'has_finconnectx_dealings', detailKey: 'finconnectx_details', q: "Q3. Are you the officer, director, direct or indirect shareholder or ultimate actual beneficiary of any companies that have any business dealings with any FinconnectX's officers, directors or employees in the past 12 months?", ph: 'Please provide details...' },
      ].map(({ key, detailKey, q, ph }) => (
        <div key={key} style={{ marginBottom: '24px' }}>
          <p style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px', lineHeight: '1.6' }}>{q}</p>
          <YesNo name={key} value={kycCompliance[key]} onChange={onYN(setKycCompliance)} details={kycCompliance[detailKey]} detailsName={detailKey} placeholder={ph} />
        </div>
      ))}
    </div>
  )

  const renderKYBCompliance = () => (
    <div>
      <p style={sec}>Compliance Questionnaire</p>
      {[
        { key: 'is_on_sanctions_list', detailKey: 'is_on_sanctions_list_details', q: 'Q1. Is the company or any of its officers, directors, direct or indirect shareholders or ultimate actual beneficiaries involved in any sanctions list?' },
        { key: 'is_sanctions_country_related', detailKey: 'is_sanctions_country_details', q: 'Q2. Is the company or any of its officers, directors, direct or indirect shareholders or ultimate actual beneficiaries involved under the laws of any country, region or territory that is the target of comprehensive, country or territory-wide Sanctions?' },
        { key: 'is_controlled_by_sanctioned', detailKey: 'is_controlled_by_sanctioned_details', q: 'Q3. Is the company directly or indirectly owned or controlled by any sanctioned or designated person on the sanctions list, or acting as a representative for its interests?' },
        { key: 'has_finconnectx_dealings', detailKey: 'finconnectx_details', q: "Q4. Has the company or any of its officers, directors, direct or indirect shareholders or ultimate beneficiaries have any business dealings with any FinconnectX's officers, directors or employees in the past 12 months?" },
        { key: 'has_improper_payments', detailKey: 'has_improper_payments_details', q: "Q5. Unless expressly stated in FinconnectX's written agreement, does the company or any of its officers, directors or employees pay, accept or provide anything of value in exchange for the opportunity to establish a business relationship with FinconnectX?" },
      ].map(({ key, detailKey, q }) => (
        <div key={key} style={{ marginBottom: '24px' }}>
          <p style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px', lineHeight: '1.6' }}>{q}</p>
          <YesNo name={key} value={kybCompliance[key]} onChange={onYN(setKybCompliance)} details={kybCompliance[detailKey]} detailsName={detailKey} placeholder="Please provide details..." />
        </div>
      ))}
    </div>
  )

  const renderAgreements = () => (
    <div>
      <p style={sec}>Agreements & Confirmations</p>
      <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '20px' }}>
        Please read and accept all agreements before submitting your application.
      </p>

      {/* T&C */}
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '16px', cursor: 'pointer' }}>
        <input type="checkbox" checked={agreements.terms_accepted} onChange={e => setAgreements(p => ({ ...p, terms_accepted: e.target.checked }))} style={{ marginTop: '3px', flexShrink: 0 }} />
        <span style={{ fontSize: '14px', color: '#374151', lineHeight: '1.6' }}>
          I have read and agree to the FinconnectX <a href="https://www.finconnectx.com/terms" target="_blank" rel="noreferrer" style={{ color: '#6b2fa0', textDecoration: 'underline' }}>Terms & Conditions</a>
        </span>
      </label>

      {/* Privacy Policy */}
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '20px', cursor: 'pointer' }}>
        <input type="checkbox" checked={agreements.privacy_accepted} onChange={e => setAgreements(p => ({ ...p, privacy_accepted: e.target.checked }))} style={{ marginTop: '3px', flexShrink: 0 }} />
        <span style={{ fontSize: '14px', color: '#374151', lineHeight: '1.6' }}>
          I have read and agree to the FinconnectX <a href="https://www.finconnectx.com/privacy-policy" target="_blank" rel="noreferrer" style={{ color: '#6b2fa0', textDecoration: 'underline' }}>Privacy Policy</a>
        </span>
      </label>

      {/* Client Unsolicited Request Confirmation */}
      <div style={{ background: '#f9fafb', borderRadius: '10px', padding: '20px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
        <p style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '4px' }}>
          Client Unsolicited Request Confirmation
        </p>
        <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '16px', lineHeight: '1.6' }}>
          This document serves to formally record that the client has exclusively initiated contact with Finconnectx Pty Ltd for the provision of services.
        </p>

        <Field title="Client Full Name *">
          <Input value={unsolicitedForm.client_full_name}
            onChange={e => setUnsolicitedForm(p => ({ ...p, client_full_name: e.target.value }))}
            placeholder="Your full name" />
        </Field>
        <Field title="Date of Initial Contact *">
          <Input type="date" value={unsolicitedForm.contact_date}
            onChange={e => setUnsolicitedForm(p => ({ ...p, contact_date: e.target.value }))} />
        </Field>
        <Field title="Services Requested *">
          <Textarea value={unsolicitedForm.services_requested}
            onChange={e => setUnsolicitedForm(p => ({ ...p, services_requested: e.target.value }))}
            placeholder="List the specific services you are requesting (e.g. OTC crypto trading, fiat-to-crypto exchange)" />
        </Field>

        <div style={{ background: '#fff', borderRadius: '8px', padding: '14px', border: '1px solid #e5e7eb', marginTop: '8px', marginBottom: '14px' }}>
          <p style={{ fontSize: '12px', color: '#6b7280', lineHeight: '1.8', margin: 0 }}>
            By checking the box below, I, <strong>{unsolicitedForm.client_full_name || '[Client Full Name]'}</strong>, confirm that:
          </p>
          <ol style={{ fontSize: '12px', color: '#6b7280', lineHeight: '1.8', marginTop: '8px', paddingLeft: '16px' }}>
            <li>I made the initial, unprompted contact with Finconnectx Pty Ltd on <strong>{unsolicitedForm.contact_date || '[Date]'}</strong> to inquire about: <strong>{unsolicitedForm.services_requested || '[Services]'}</strong></li>
            <li>Finconnectx Pty Ltd, nor any person acting on their behalf, did not solicit, market, or promote these services to me in any way before this contact.</li>
            <li>I understand that the ability of Finconnectx Pty Ltd to provide services is based on my unprompted request and that any future services must also adhere to regulatory requirements.</li>
          </ol>
        </div>

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
          <input type="checkbox" checked={agreements.unsolicited_request_accepted}
            onChange={e => setAgreements(p => ({ ...p, unsolicited_request_accepted: e.target.checked }))}
            style={{ marginTop: '3px', flexShrink: 0 }} />
          <span style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6', fontWeight: '500' }}>
            I confirm that this is an unsolicited request and I am submitting this application of my own free will.
          </span>
        </label>
      </div>

      {/* IDV 提示 */}
      <div style={noteBox}>
        {isKYC ? t('idvNote') : t('idvNoteKYB')}
      </div>

      {/* 未全部勾选提示 */}
      {(!agreements.terms_accepted || !agreements.privacy_accepted || !agreements.unsolicited_request_accepted) && (
        <div style={{ background: '#fef9c3', border: '1px solid #fde047', borderRadius: '8px', padding: '12px', marginTop: '8px', fontSize: '13px', color: '#854d0e' }}>
          ⚠ Please accept all agreements above before submitting.
        </div>
      )}
    </div>
  )

  const renderContent = () => {
    if (step === steps.length) {
      return (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <div style={{ fontSize: '52px', marginBottom: '16px' }}>{t('successIcon')}</div>
          <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px' }}>{t('successTitle')}</h2>
          <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '8px' }}>{t('successMsg')}</p>
          <p style={{ color: '#9ca3af', fontSize: '13px' }}>{t('successId')}: <strong style={{ color: '#374151', fontSize: '16px' }}>{createdUserId}</strong></p>
          <div style={{ ...noteBox, marginTop: '20px', textAlign: 'left' }}>
            {isKYC ? t('idvNote') : t('idvNoteKYB')}
          </div>
        </div>
      )
    }
    if (isKYC) return [renderStep0, renderKYCStep1, renderBusinessStep, renderBankWalletStep, renderKYCCompliance, renderAgreements][step]()
    return [renderStep0, renderKYBStep1, renderKYBStep2, renderKYBStep3, renderBusinessStep, renderBankWalletStep, renderKYBCompliance, renderAgreements][step]()
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6', padding: '32px 16px' }}>
      <div style={{ position: 'fixed', top: '16px', right: '16px', zIndex: 100, display: 'flex', gap: '4px', background: '#fff', borderRadius: '8px', padding: '4px', boxShadow: '0 1px 4px rgba(0,0,0,0.12)' }}>
        {['en', 'zh'].map(l => (
          <button key={l} onClick={() => setLang(l)}
            style={{ padding: '6px 14px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '500', background: lang === l ? '#6b2fa0' : 'transparent', color: lang === l ? '#fff' : '#6b7280' }}>
            {l === 'en' ? 'EN' : '中文'}
          </button>
        ))}
      </div>

      <div style={{ maxWidth: '640px', margin: '0 auto', background: '#fff', borderRadius: '12px', padding: '32px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <img src="https://images.squarespace-cdn.com/content/v1/68e33e85f8582a5c9526b2e5/ae04f53d-f33e-4574-b2e0-2afc8d78a35b/Screenshot+2025-12-08+at+9.07.32%E2%80%AFPM.png" alt="FinconnectX" style={{ height: '40px', objectFit: 'contain' }} />
        </div>
        <h1 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '4px' }}>{isKYC ? t('kycTitle') : t('kybTitle')}</h1>
        <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '24px' }}>FinconnectX Platform</p>

        {step < steps.length && (
          <div style={{ marginBottom: '28px' }}>
            <div style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
              {steps.map((_, i) => <div key={i} style={{ flex: 1, height: '4px', borderRadius: '2px', background: i < step ? '#10b981' : i === step ? '#6b2fa0' : '#e5e7eb' }} />)}
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              {lang === 'en' ? `Step ${step + 1} of ${steps.length} — ` : `第 ${step + 1} 步，共 ${steps.length} 步 — `}
              <span style={{ color: '#374151', fontWeight: '500' }}>{steps[step]}</span>
            </div>
          </div>
        )}

        {renderContent()}

        {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '12px', marginTop: '16px', color: '#dc2626', fontSize: '13px' }}>{error}</div>}

        {step < steps.length && (
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px' }}>
            {step > 0
              ? <button onClick={() => { setStep(s => s - 1); setFieldErrors({}); setError('') }}
                  style={{ padding: '10px 24px', borderRadius: '8px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: '14px' }}>
                  {t('back')}
                </button>
              : <div />}
            {step < steps.length - 1
              ? <button onClick={handleNext}
                  style={{ padding: '10px 24px', borderRadius: '8px', border: 'none', background: '#6b2fa0', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                  {t('next')}
                </button>
              : <SubmitButton loading={loading}
                  agreed={agreements.terms_accepted && agreements.privacy_accepted && agreements.unsolicited_request_accepted}
                  onClick={handleSubmit} label={t('submit')} loadingLabel={t('submitting')} />}
          </div>
        )}
      </div>
    </div>
  )
}